import { Injectable } from '@angular/core';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Injectable({
  providedIn: 'root'
})
export class DateService {

  constructor() { }

  formatDateToCustomString(date: Date): string {
    if ((date as any)._d) {
      date = (date as any)._d
    }
    const parsedDate = date instanceof Date ? date : new Date(date);
    if (isNaN(parsedDate.getTime())) {
      throw new Error('Invalid date provided to formatDateToCustomString');
    }
    const year = parsedDate.getFullYear();
    const month = ('0' + (parsedDate.getMonth() + 1)).slice(-2);
    const day = ('0' + parsedDate.getDate()).slice(-2);
    const hours = ('0' + parsedDate.getHours()).slice(-2);
    const minutes = ('0' + parsedDate.getMinutes()).slice(-2);

    return `${year}-${month}-${day} ${hours}:${minutes}`;
  }

  formatDate(date: Date): string {
    if ((date as any)._d) {
      date = (date as any)._d
    }
    const parsedDate = date instanceof Date ? date : new Date(date);
    if (isNaN(parsedDate.getTime())) {
      throw new Error('Invalid date provided to formatDateToCustomString');
    }
    const year = parsedDate.getFullYear();
    const month = ('0' + (parsedDate.getMonth() + 1)).slice(-2);
    const day = ('0' + parsedDate.getDate()).slice(-2);
    const hours = ('0' + parsedDate.getHours()).slice(-2);
    const minutes = ('0' + parsedDate.getMinutes()).slice(-2);

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }

  formatDateToCustomStringNoTime(date: Date): string {
    if ((date as any)._d) {
      date = (date as any)._d
    }
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);

    return `${day}/${month}/${year}`;
  }

  formatDateDDMMYYYY(date: Date): string {
    if ((date as any)._d) {
      date = (date as any)._d
    }
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);

    return `${day}-${month}-${year}`;
  }

  /**
   * Formato para enviar fechas al servidor
   * @param date fecha
   * @returns fecha en formato yyyy-mm-dd
   */
  sendFormat(date: Date): string {
    if ((date as any)._d) {
      date = (date as any)._d
    }
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);

    return `${year}-${month}-${day}`;
  }

  parseDateString(dateString: string): Date | null {
    const parts = dateString.split('/');
    if (parts.length !== 3) {
      return null;
    }

    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1;
    const year = parseInt(parts[2], 10);

    return new Date(year, month, day);
  }

  formatCustomStringToDate(customDateString: string): string {
    // Manejar fecha en formato ISO (con T y timezone)
    if (customDateString.includes('T')) {
      const date = new Date(customDateString);
      const day = ('0' + date.getDate()).slice(-2);
      const month = ('0' + (date.getMonth() + 1)).slice(-2);
      const year = date.getFullYear();
      const hours = ('0' + date.getHours()).slice(-2);
      const minutes = ('0' + date.getMinutes()).slice(-2);
      return `${day}/${month}/${year} ${hours}:${minutes}`;
    }
    
    // Formato original yyyy-mm-dd HH:mm
    const [datePart, timePart] = customDateString.split(' ');
    const [year, month, day] = datePart.split('-');
    const [hours, minutes] = timePart.split(':');

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }

  formatCustomStringToDateNoTime(customDateString: string): string {
    // Manejar fecha en formato ISO (con T y timezone)
    if (customDateString.includes('T')) {
      const date = new Date(customDateString);
      const day = ('0' + date.getDate()).slice(-2);
      const month = ('0' + (date.getMonth() + 1)).slice(-2);
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    }
    
    // Formato original yyyy-mm-dd
    const [datePart] = customDateString.split(' ');
    const [year, month, day] = datePart.split('-');

    return `${day}/${month}/${year}`;
  }

  formatDateToSpanishFormat(date: Date): string {
    if ((date as any)._d) {
      date = (date as any)._d
    }
    const monthNames = [
      'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ];
    
    const day = date.getDate();
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();

    return `${day} de ${month} de ${year}`;
  }

}
